export default "<h3>User Groups Settings</h3>\n<app-api-gateway-settings></app-api-gateway-settings>\n"